import { getDeploymentConfig } from "../deployment-config";

/**
 * Running against a local API (`./dev.sh`), which takes no tokens: the admin
 * pages skip sign-in and the footer shows the Admin link to everyone.
 */
export function isLocalDev(): boolean {
  try {
    const apiUrl = getDeploymentConfig().apiUrl || "";
    return /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/.test(apiUrl);
  } catch {
    return false;
  }
}
